import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteAction } from "../../services/action";
import { toast } from "react-toastify";
import { IIndicators } from "../../types";

const useDeleteAction = (indicators: IIndicators) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteAction,

    onMutate: () => {
      indicators.setIsProcessRunning(true);
    },

    onSuccess: (status) => {
      if (status === 200) {
        queryClient.invalidateQueries({ queryKey: ['notification-actions'] });
        indicators.setIsProcessRunning(false);
        toast.success("Action deleted successfully!");
      }
    },

    onError: (error: any) => {
      indicators.setIsProcessRunning(false);
      toast.error(error.response?.data?.message);
      indicators.setIsServiceError(error.response?.data?.message);
    },
  });
};

export default useDeleteAction;
